import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { advisorsSelector } from 'components/features/coaching/advisorMeeting/selectors/advisorsSelector'
import { getItemsByKey } from 'helpers/normalizeHelpers'


export const topAdvisorsSelector = createSelector(
  advisorsSelector,
  (advisors) => {
    const ids = advisors.topAdvisors.data
    if (!ids) {
      return null
    }

    return getItemsByKey(advisors.advisors.byKey, ids)
  }
)


export const topReviewsSelector = createSelector(
  advisorsSelector,
  (advisors) => {
    const ids = advisors.topReviews.data
    if (!ids) {
      return null
    }

    return getItemsByKey(advisors.reviews.byKey, ids)
  }
)

export function getAdvisorsRequestErrors (store: State): Record<string, string[]> | null {
  return advisorsSelector(store).advisorsRequest?.errorsMap || null
}

export const timeslotsRequestSelector = createSelector(
  advisorsSelector,
  (advisors) => advisors.timeslotsRequest
)
